import userAccountMutations from "./mutations.js";
import userAccountActions from "./actions.js";
import userAccountGetters from "./getters.js";

export default {
  namespaced: true, // put true if want enable modules
  state() {
    return {
      // Result of the most recent change-password / revoke-sessions call, as returned by the API.
      lastOperation: null,
    };
  },
  mutations: userAccountMutations,
  actions: userAccountActions,
  getters: userAccountGetters,
};
